export const captchaInput = {
  data () {
    return {
      phoneCode: [
        { value: '', autofocus: true },
        { value: '', autofocus: false },
        { value: '', autofocus: false },
        { value: '', autofocus: false },
        { value: '', autofocus: false },
        { value: '', autofocus: false }
      ]
    };
  },
  methods: {
    /** 手机验证码输入 change */
    phoneCodeChange (val, item, index) {
      console.log('val: ', val.data || val.target.value, index);
      val = val.data || val.target.value;
      let input = document.getElementsByClassName('phone-code-input');
      if (val.length == 6) {
        let numArr = val.split('');
        this.phoneCode.forEach((item, i) => {
          item.value = numArr[i];
        });
        input && input[5].focus();
        return;
      } else if (item.value.length > 1) {
        item.value = item.value.split('')[0];
      }

      if (index < 5 && val) { // 输入框没值返回undefined
        input && input[index + 1].focus();
      }

      if (index > 0 && (val === null || val === '')) { // 清空后返回的值为null
        input && input[index - 1].focus();
      }
    },
    /** 提交前处理六位验证码 */
    prePhoneCode () {
      return this.phoneCode.map(item => item.value).join('');
    }
  }
};
